/*
@license
  Expanse by Archetype Themes (https://archetypethemes.co)
  Access unminified JS in assets/theme.js

  Use this event listener to run your own JS outside of this file.
  Documentation - https://archetypethemes.co/blogs/expanse/javascript-events-for-developers

  document.addEventListener('page:loaded', function() {
    // Page has loaded and theme assets are ready
  });
*/

if (console && console.log) {
  console.log(
    "Expanse theme (" +
    theme.settings.themeVersion +
    ") by ARCHΞTYPE | Learn more at https://archetypethemes.co"
  );
}

(function () {
  "use strict";

  // --- Cloré: Open minicart in a way that works on both mobile (drawer) and desktop (dropdown)
  window.CloreOpenMiniCart = function (opts = {}) {
    const settings = Object.assign(
      {
        scrollToCartOnDesktop: true,
        desktopDelayMs: 250,
        desktopMinWidth: 990,
      },
      opts
    );

    const isDesktop = window.matchMedia(`(min-width: ${settings.desktopMinWidth}px)`).matches;

    // Mobile drawer open (overlay)
    try {
      document.dispatchEvent(new CustomEvent("cart:open", { bubbles: true }));
    } catch (e) { }

    // Desktop dropdown open: click cart trigger
    const openDesktopDropdown = () => {
      const cartTrigger =
        document.querySelector('[data-header-cart]') ||
        document.querySelector(".site-header__cart") ||
        document.querySelector('a[href="/cart"]') ||
        document.querySelector('a[href="/cart/"]');

      if (cartTrigger) cartTrigger.click();
    };

    if (isDesktop && settings.scrollToCartOnDesktop) {
      const header = document.querySelector("#SiteHeader") || document.querySelector(".header-section");
      if (header?.scrollIntoView) {
        header.scrollIntoView({ behavior: "smooth", block: "start" });
      } else {
        window.scrollTo({ top: 0, behavior: "smooth" });
      }

      window.setTimeout(openDesktopDropdown, settings.desktopDelayMs);
    } else {
      openDesktopDropdown();
    }
  };

  if (
    window.Shopify &&
    window.Shopify.theme &&
    navigator &&
    navigator.sendBeacon &&
    window.Shopify.designMode
  ) {
    navigator.sendBeacon(
      "https://api.archetypethemes.co/api/beacon",
      new URLSearchParams({
        shop: window.Shopify.shop,
        themeName:
          window.theme &&
          window.theme.settings &&
          `${window.theme.settings.themeName} v${window.theme.settings.themeVersion}`,
        role: window.Shopify.theme.role,
        route: window.location.pathname,
        themeId: window.Shopify.theme.id,
        themeStoreId: window.Shopify.theme.theme_store_id || 0,
        isThemeEditor: !!window.Shopify.designMode,
      })
    );
  }

  /*============================================================================
    Things that don't require DOM to be ready
  ==============================================================================*/

  /*============================================================================
    Things that require DOM to be ready
  ==============================================================================*/
  function DOMready(callback) {
    if (document.readyState != "loading") callback();
    else document.addEventListener("DOMContentLoaded", callback);
  }

  DOMready(function () {
    document.dispatchEvent(new CustomEvent("page:loaded"));

    let lastScrollTop = 0;
    const body = document.documentElement;
    window.addEventListener(
      "scroll",
      function () {
        let st = window.pageYOffset || document.documentElement.scrollTop;
        if (st > lastScrollTop && st > 150) {
          // Downscroll
          body.classList.add("scroll-down");
          body.classList.remove("scroll-up");
        } else if (st < lastScrollTop) {
          // Upscroll
          body.classList.add("scroll-up");
          body.classList.remove("scroll-down");
        }
        lastScrollTop = Math.max(0, st); // For Mobile or negative scrolling
      },
      { passive: true }
    );
  });
})();
